<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="green">
                        <v-toolbar-title class="my-0 py-0">Alerta Próximos Mantenimientos - Bienes</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="PDF()">Exportar PDF</v-btn>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                </v-card>
                <v-card color="green lighten-4" class="py-0 my-0" id="pdfpresupuesto">
                    <v-card-text>
                        <v-data-table dense :headers="headers" group-by="equipo" :items="listadoequipo" locale="es-ar"
                            class="elevation-1" :items-per-page="500" :item-class="row_classes" hide-default-footer>

                            <template v-slot:group.header="{ items }">
                                <td class="text-xs-right">
                                    <strong>{{ items[0].equipo }}</strong>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>

            </v-form>
        </v-app>
    </div>
</template>

<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
import html2pdf from 'html2pdf.js'
export default {
    data: (vm) => ({
        valid: false,
        deshabilitar: false,
        lazy: false,
        fecha: moment().format("DD/MM/YYYY"),
        listadoequipo: [],
        datos: [],
        headers: [
            { text: "Equipo", value: "equipo", width: "30%", sortable: false },
            { text: "", value: "", width: "30%", sortable: false },
            { text: "Item", value: "item", width: "5%", sortable: false },
            { text: "Tarea", value: "tarea", width: "40%", sortable: false },
            { text: "Actual", value: "actual", width: "10%", sortable: false },
            { text: "Prox. Manten.", value: "proxmanten", width: "10%", sortable: false },
        ],
    }),
    computed: {

        show: {
            get() {
                this.cargarEquipo();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        row_classes(item) {
            if (item.tipo == "Meses" && (moment(item.actual, "DD/MM/YYYY") > moment(item.proxmanten, "DD/MM/YYYY"))) {
                return "red";
            }
            if ((item.tipo == "Km" || item.tipo == "Horas") && (parseFloat(item.actual) < parseFloat(item.proxmanten))) {
                return "red";
            }
            if (item.tipo == "Meses" && (moment(item.actual, "DD/MM/YYYY") < moment(item.proxmanten, "DD/MM/YYYY"))) {
                return "yellow";
            }
            if ((item.tipo == "Km" || item.tipo == "Horas") && (parseFloat(item.actual) > parseFloat(item.proxmanten))) {
                return "yellow";
            }

        },

        vaciarModels() {
            this.listadoequipo = []
        },
        cargarEquipo() {
            let self = this;
            axios
                .get("/SSGG/Proxmanten?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.listadoequipo = response.data;
                })
                .catch((error) => {
                    self.listadoequipo = "";
                    console.log(error);
                });
        },

        PDF() {
            var element = document.getElementById('pdfpresupuesto');
            var opt = {
                margin: 0.2,
                filename: "alertas.pdf",
                image: { type: 'jpeg', quality: 0.95 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'in', format: 'A4', orientation: 'landscape' }
            };

            // html2pdf().from(element).set(opt).save();

            html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
                window.open(pdf.output('bloburl'), '_blank');
            });
        },

    }
};
</script>